import { render, staticRenderFns } from "./business-role.vue?vue&type=template&id=33d9270a&scoped=true"
import script from "./business-role.vue?vue&type=script&lang=js"
export * from "./business-role.vue?vue&type=script&lang=js"
import style0 from "./business-role.vue?vue&type=style&index=0&id=33d9270a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9270a",
  null
  
)

export default component.exports